import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody
} from 'reactstrap';
import { connect } from 'react-redux';
import { IEncDelayEdit, IAuthReduxProps } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { getPromoteurs } from '../../flux/actions/promoteurActions';
import { editEncVerseDelay } from '../../flux/actions/encaissementActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faHourglassHalf, faPen, faPlus, faSpinner, faSquare, faTimes } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import { constants } from '../../types/constants';
import DatePicker from "reactstrap-date-picker";
import { getEncModeRegl } from '../../services/misc';
import moment from "moment";

const EncDelayEdit = ({
  modal,
  setModal,
  modalData,
  editEncVerseDelay,
  auth
 }: IEncDelayEdit) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [dateCValue, setDateCValue] = useState('');
  const [dateEInitialValue, setDateEInitialValue] = useState('');
  const [dateEValue, setDateEValue] = useState('');
  const [comment, setComment] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalOpenedHandle = () => {
    if(modalData){
      setIdValue(modalData["id"]);
      setDateCValue(modalData["DATE_PORTEFEUILLE"]);
      setDateEInitialValue(modalData["DATE_REGLEMENT"]);
      setDateEValue(modalData["DATE_REGLEMENT"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setDateCValue('');
    setDateEInitialValue('');
    setDateEValue('');
    setComment('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success("Demande de prolongation envoyée avec succès");
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const editHandle = async () => {
    if(!dateEValue){
      alert.error("Veuillez sélectionner une date");
      return
    }

    setDisableSubmit(true);
    editEncVerseDelay(idValue, new Date(dateEValue), comment, auth?.user?.id, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faHourglassHalf} />&nbsp;&nbsp;Demande prolongation du versement du chèque</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="cDatepickerReq">Date du chèque</Label>
                    <DatePicker id="cDatepickerReq"
                      value={dateCValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="eDatepickerReq">Date d'Encaissement (prolongation)</Label>
                    <DatePicker id="eDatepickerReq"
                      value={dateEValue}
                      dateFormat={constants.DP_DATE_FORMAT}
                      dayLabels={constants.DP_DAYS}
                      monthLabels={constants.DP_MONTHS}
                      weekStartsOn={constants.DP_WEEK_START}
                      onChange={e => setDateEValue(e)} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="12">
                  <FormGroup>
                    <Label for="commentDateEnc">Commentaire</Label>
                    <Input id="commentDateEnc" type="text" disabled={!dateEValue || moment(dateEInitialValue).isSame(dateEValue, "date")} placeholder="Commentaire..." value={comment} onChange={e => setComment(e.target.value)} className="form-control" />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={editHandle}
                  disabled={disableSubmit || !dateEValue || moment(dateEInitialValue).isSame(dateEValue, "date")}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Envoyer</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, { editEncVerseDelay, getPromoteurs })(EncDelayEdit);
